import {
  AccordionDetails,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Link,
  Radio,
  RadioGroup,
  Stack
} from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { sendRequest } from 'src/hooks/useFetch';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { clearMessage, setMessage } from 'src/store/Message';
import { ISIVChecklistRequirementsforEcrfcompletion } from 'src/types/SIVChecklist';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import {
  IRequirementsforEcrfcompletionMandatory,
  ISIVChecklistMandatory,
  ISIVChecklistModifiedKeys,
  ISIVChecklistModifiedKeysOfKeys,
  MandatoryData
} from './useSivChecklist';
import { setIsSaveButtonDisable } from 'src/store/sivCheckList';

export interface IRequirementsforEcrfcompletion {
  getSivChecklistData: (key: ISIVChecklistModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  requirementsforEcrfCompletionData: ISIVChecklistRequirementsforEcrfcompletion;
  updateRequirementsforEcrfCompletion: (data: ISIVChecklistRequirementsforEcrfcompletion) => void;
  isUpdate: boolean;
  isChange: boolean;
  setIsChange: (step: ISIVChecklistModifiedKeys, key: ISIVChecklistModifiedKeysOfKeys, val: boolean) => void;
  updateSIVChecklistMandatoryData: (key: keyof ISIVChecklistMandatory, value: MandatoryData) => void;
  mandatory: IRequirementsforEcrfcompletionMandatory;
  validaterequirementsforEcrfcompletion: any;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}

const RequirementsforEcrfcompletion: React.FunctionComponent<IRequirementsforEcrfcompletion> = ({
  getSivChecklistData,
  saveDisable,
  isUpdate,
  requirementsforEcrfCompletionData,
  updateRequirementsforEcrfCompletion,
  isChange,
  setIsChange,
  mandatory,
  updateSIVChecklistMandatoryData,
  validaterequirementsforEcrfcompletion,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  // const [requirementsForEcrfData, setRequirementsForEcrfData] = useState<any>({
  //   siv_checklist_ecrf_guidelines: sivChecklistData.siv_checklist_ecrf_guidelines,
  //   siv_checklist_ecrf_guidelines_comm: sivChecklistData.siv_checklist_ecrf_guidelines_comm || ''
  // });
  //const [isChange, setIsChange] = useState(false);
  // const [isUpdate, setIsUpdate] = useState(sivChecklistData.study_id ? true : false);
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const { sivcDataUpdateSuccessMsg, sivcMendatoryInfoErrorMsg } = useFieldTranslation();
  // const [validate, setValidate] = useState({
  //   siv_checklist_ecrf_guidelines: false
  // } as any);

  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { checkPermission } = usePermissionWrapper();
  const user = useUser();
  const isDisable = checkPermission('update_siv_checklist');
  const selectedRowData: any = useAppSelector(state => state.sivCheckList.selectedRowData);
  const saveButtonDisable: any = useAppSelector(state => state.sivCheckList.disableSaveButtonProps);

  const handleRequirementsForEcrfData = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    const value = formattedVal;
    dispatchApp(clearMessage());
    if (e.target.type === 'radio' && value === 'Y') {
      updateRequirementsforEcrfCompletion({
        ...requirementsforEcrfCompletionData,
        [e.target.name]: value,
        [`${e.target.name}_comm`]: ''
      });
      //setValidate({ ...validate, [e.target.name]: false });
      updateSIVChecklistMandatoryData('requirementsforEcrfcompletion', { ...mandatory, [e.target.name]: false });
    } else {
      updateRequirementsforEcrfCompletion({ ...requirementsforEcrfCompletionData, [e.target.name]: value });
    }
    const validateKey = `${e.target.name.replace('_comm', '')}`;
    if (e.target.name?.indexOf('_comm') !== -1) {
      if (!(value && value !== null && value !== '')) {
        //setValidate({ ...validate, [validateKey]: true });
        updateSIVChecklistMandatoryData('requirementsforEcrfcompletion', { ...mandatory, [validateKey]: true });
      } else {
        //setValidate({ ...validate, [validateKey]: false });
        updateSIVChecklistMandatoryData('requirementsforEcrfcompletion', { ...mandatory, [validateKey]: false });
      }
    }
    // dispatch(setIsSaveButtonDisable(false))
    dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, requirementsforECrfcompletion: false }));
    setConfirmExitValue(dispatch, true);
    // setIsChange(true);
    // setIsChanged(true);
  };

  const updateRequirementsForEcrfData = async () => {
    const options = {
      site_id: selectedSite,
      study_id: studyId,
      data: {
        updated_by: user.user,
        monitoring_visit_id: selectedRowData.id,
        siv_checklist: { step_two: { requirements_for_ecrf_completion: requirementsforEcrfCompletionData } }
      },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      if (isChange) {
        if (isUpdate) {
          if (requirementsforEcrfCompletionData.siv_checklist_ecrf_guidelines !== null) {
            await sendRequest('update_sivChecklist_data', options);
            if (isPublished) {
              SignatureBreaking();
            }
            getSivChecklistData('requirementsforEcrfcompletion', false);
            setConfirmExitValue(dispatch, false);
            setIsChange('Step2', 'requirementsforEcrfcompletion', false);
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
        if (!isUpdate) {
          if (requirementsforEcrfCompletionData.siv_checklist_ecrf_guidelines !== null) {
            await sendRequest('create_sivChecklist_data', options);
            getSivChecklistData('requirementsforEcrfcompletion', true);
            setConfirmExitValue(dispatch, false);

            setIsChange('Step2', 'requirementsforEcrfcompletion', false);
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
      } else if (!isChange && requirementsforEcrfCompletionData.siv_checklist_ecrf_guidelines === null) {
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      } else if (validaterequirementsforEcrfcompletion) {
        dispatchApp(setMessage({ msgDetails: 'No data modified', severity: 'info' }));
      } else {
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      }
      //dispatch(setIsSaveButtonDisable(false))
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, requirementsforECrfcompletion: true }));
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }
  };

  return (
    <>
      <AccordionDetails className="sq-checklist-tab">
        <Grid container className="checklist-radio-actions">
          <Grid md={12}>
            <Grid container>
              <Grid md={9}>
                Have eCRF completion guidelines been shared with the site?{' '}
                <Link underline="always">(Link to eCRF guidelines)</Link> <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <FormControl>
                  <RadioGroup
                    value={requirementsforEcrfCompletionData.siv_checklist_ecrf_guidelines}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="siv_checklist_ecrf_guidelines"
                    onChange={handleRequirementsForEcrfData}
                  >
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid container className="fixed-buttons-block">
        <Grid md={12} display="flex" justifyContent="flex-end">
          <Stack spacing={2} direction="row">
            {isDisable ? (
              <Button
                onClick={updateRequirementsForEcrfData}
                disabled={saveButtonDisable?.requirementsforECrfcompletion || !checkedInStartDate}
                variant="text"
              >
                SAVE
              </Button>
            ) : (
              ''
            )}
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default RequirementsforEcrfcompletion;
